'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/redux-ui/~/react/react.js
// module id = 301
// module chunks = 0